import React from 'react';
import { SchematicShell } from './SchematicPrimitives';

/**
 * Desk monitor elevation (pairs with dormMonitorRenderer).
 *
 * Not an alias of TelevisionSchematic: a TV is a bare wall-hung panel, while
 * this renderer builds base disc -> neck -> panel, and the object's height
 * INCLUDES the stand. Drawing it as a full-height panel would misreport where
 * the screen actually sits above the desk. Constants track the renderer's.
 */
const IN = 0.0254;

const BEZEL_SIDE = 0.25 * IN;
const BEZEL_TOP = 0.25 * IN;
const BEZEL_BOTTOM = 0.6 * IN;
const NECK_DIAMETER = 1.5 * IN;
const NECK_HEIGHT = 3.5 * IN;
const BASE_W = 9 * IN;
const BASE_H = 0.4 * IN;

export function DormMonitorSchematic({
  widthMeters: width,
  heightMeters: height,
  strokeColor,
  strokeWidth,
}) {
  const cx = width / 2;
  const half = (d) => Math.min(d, width) / 2;

  // Panel occupies everything above the stand; y=0 is the top of the object.
  const panelH = Math.max(0, height - (BASE_H + NECK_HEIGHT));
  const neckTop = panelH;
  const baseTop = height - BASE_H;

  const screenW = Math.max(0, width - BEZEL_SIDE * 2);
  const screenH = Math.max(0, panelH - BEZEL_TOP - BEZEL_BOTTOM);

  return (
    <SchematicShell
      width={width}
      height={height}
      strokeColor={strokeColor}
      strokeWidth={strokeWidth}
      drawFrame={false}
    >
      {/* Panel housing */}
      <rect
        x={0}
        y={0}
        width={width}
        height={panelH}
        fill="none"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
      {/* Screen face, inset by the bezels */}
      {screenW > 0 && screenH > 0 && (
        <rect
          x={BEZEL_SIDE}
          y={BEZEL_TOP}
          width={screenW}
          height={screenH}
          fill={strokeColor}
          fillOpacity={0.08}
          stroke={strokeColor}
          strokeWidth={strokeWidth}
          vectorEffect="non-scaling-stroke"
        />
      )}
      {/* Stand neck */}
      <rect
        x={cx - half(NECK_DIAMETER)}
        y={neckTop}
        width={half(NECK_DIAMETER) * 2}
        height={NECK_HEIGHT}
        fill="none"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        vectorEffect="non-scaling-stroke"
      />
      {/* Stand base */}
      <rect
        x={cx - half(BASE_W)}
        y={baseTop}
        width={half(BASE_W) * 2}
        height={BASE_H}
        fill={strokeColor}
        fillOpacity={0.12}
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        vectorEffect="non-scaling-stroke"
      />
    </SchematicShell>
  );
}
